<template>
  <div class="model">
    <img src="../assets/273.png" alt="" @click="dialogVisible=true">
    <el-dialog
        title="请您留言"
        :visible.sync="dialogVisible"
        width="15%"
        :close-on-click-modal="false"
        :before-close="handleClose">
      <el-form ref="formName" :model="form" :rules="rules">
        <el-form-item prop="name">
          <el-input v-model="form.name" placeholder="请输入姓名"></el-input>
        </el-form-item>
        <el-form-item prop="phone">
          <el-input v-model="form.phone" placeholder="请输入电话"></el-input>
        </el-form-item>
        <el-form-item prop="addr">
          <el-input v-model="form.addr" placeholder="请输入地址"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="info">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "model",
  data(){
    return{
      dialogVisible:false,
      form:{
        name:'',
        phone:'',
        addr:''
      },
      rules: {
        name: [{required: true, message: '姓名不得为空', trigger: 'blur'}],
        phone: [{required: true, message: '电话不得为空', trigger: 'blur'}],
        addr: [{required: true, message: '地址不得为空', trigger: 'blur'}],
      }
    }
  },
  mounted() {
    this.dialogVisible = false;
  },
  methods:{
    info(){
      this.$refs.formName.validate((valid) => {
        if(valid){
          let data = {
            msgName: this.form.name,
            msgPhont: this.form.phone,
            msgAddress: this.form.addr,
          };
          this.$axios.post('http://82.156.125.76:5000/api/Byt_Ent_Gateway/DescAdd',data).then(res=>{
            this.$message({
                  message: "留言成功,请耐心等待客服联系...",
                  type: "success",
                });
            this.dialogVisible =false;
          })
        }
      })
    }
  }
}
</script>

<style >
.model{
  clear: both;
  float: right;
}
.el-dialog__header{
  background-color:#66b1ff ;

}
.el-dialog__title,.el-dialog__headerbtn .el-dialog__close{
  color: #fff !important;
}
</style>